export default "__VITE_ASSET__coLxxAbq__"